import { META_DATA_REDUX_STORE_UPDATE } from './actionTypes';

export const updateMetaData = data => {
    return {
        type: META_DATA_REDUX_STORE_UPDATE,
        data,
    };
};
